export default {
  auth: true,
  bidder: true,
  slug: 'bidder',
}
